<template>
  <div class="received-place-list">
    <TitleBar :text="$t('ReceivedPlaceList.topic')" :showIconButton="false" @clickCloseButton="clickCloseButton" />
    <div class="head">
      <button class="tab" :class="{active: currentTab === 1}" @click="currentTab = 1">
        <div style="margin-left: -9px; display: flex; flex-direction: column; justify-content: center; align-items: center; width: 36px; height: 36px;">
          <img style="width: 18px; height: 18px;" :src="util.getImagePath('out_gray@2x.png')" :srcset="util.getImageSet('out_gray')">
          <img style="width: 18px; height: 18px; margin-top: -9px;" :src="util.getImagePath('in_orange@2x.png')" :srcset="util.getImageSet('in_orange')">
        </div>
        <label>{{ $t('ReceivedPlaceList.all') }}</label>
      </button>
      <button class="tab" :class="{active: currentTab === 2}" @click="currentTab = 2">
        <img :src="util.getImagePath('out_gray@2x.png')" :srcset="util.getImageSet('out_gray')">
        <label>{{ $t('ReceivedPlaceList.send') }}</label>
      </button>
      <button class="tab" :class="{active: currentTab === 3}" @click="currentTab = 3">
        <img :src="util.getImagePath('in_orange@2x.png')" :srcset="util.getImageSet('in_orange')">
        <label>{{ $t('ReceivedPlaceList.received') }}</label>
      </button>
    </div>
    <div class="body">
      <div class="loading-animation-container" v-if="!isFinished">
        <div class="loading-animation primary"></div>
      </div>
      <div class="empty-list" v-if="receivedPlaceList.length <= 0 && isFinished">{{ $t('ReceivedPlaceList.emptyList') }}</div>
      <button class="mini-received-place-card-button" v-for="receivedPlace in receivedPlaceList"
        :key="`${receivedPlace.sender.uid}-${receivedPlace.promptpai_id}-${receivedPlace.timestamp}`"
        @click="clickMiniReceivedPlaceCardButton(receivedPlace.promptpai_id, receivedPlace.recent_type === 'R' ? receivedPlace.noti_id : null)"
        :class="{new: receivedPlace.status === 'N' && receivedPlace.recent_type === 'R'}" v-if="(currentTab === 1) || (currentTab === 2 && receivedPlace.recent_type === 'S') || (currentTab === 3 && receivedPlace.recent_type === 'R')">
        <MiniReceivedPlaceCard
          :isSent="receivedPlace.recent_type === 'S'"
          :senderProfilePath="receivedPlace.recent_type === 'R' ? receivedPlace.sender.profile_picture_fullpath : receivedPlace.receiver.profile_picture_fullpath"
          :senderDisplayName="receivedPlace.recent_type === 'R' ? receivedPlace.sender.display_name : receivedPlace.receiver.display_name"
          :code="receivedPlace.promptpai_id"
          :nameTh="receivedPlace.promptpai_name_th"
          :nameEn="receivedPlace.promptpai_name_en"
          :timestamp="receivedPlace.timestamp" />
      </button>
    </div>
  </div>
</template>

<script>
import TitleBar from '@/components/TitleBar.vue'
import MiniReceivedPlaceCard from '@/components/MiniReceivedPlaceCard.vue'

export default {
  name: 'ReceivedPlaceList',
  components: {
    TitleBar,
    MiniReceivedPlaceCard
  },
  data () {
    return {
      currentTab: 1,
      receivedPlaceList: [],
      isFinished: false
    }
  },
  mounted () {
    var self = this
    self.getReceivedPlaceList()
    self.$root.$on('refreshReceivedLocationList', self.getReceivedPlaceList)
    window.gtag('event', 'view_item_list', {'event_label': `view_sent_and_received_place_list`})
  },
  methods: {
    clickCloseButton () {
      var self = this
      self.$router.back()
    },
    getReceivedPlaceList () {
      var self = this
      self.isFinished = false
      var userProfile = {}
      var uuid = JSON.parse(self.getPromptPaiCookies('Uuid'))
      var isAuthenticated = JSON.parse(self.getPromptPaiCookies('isAuthenticated'))
      if (isAuthenticated) {
        userProfile = JSON.parse(self.getPromptPaiCookies('UserProfile'))
        uuid = undefined
      }
      self.pp.getRecentPlaces(
        'name' in userProfile ? userProfile.name : undefined,
        'longdousertoken' in userProfile ? userProfile.longdousertoken : undefined,
        uuid,
        0,
        'recents',
        0,
        undefined,
        (result) => {
          if (result.status.code === 200) {
            self.receivedPlaceList = result.data
          } else if (result.status.code === 401) {
            self.loginAgain()
          } else if (result.status.code === 403) {
          } else {
          }
          self.isFinished = true
        }
      )
    },
    // getReceivedPlaceList () {
    //   var self = this
    //   var userProfile = {}
    //   var uuid = JSON.parse(self.getPromptPaiCookies('Uuid'))
    //   var isAuthenticated = JSON.parse(self.getPromptPaiCookies('isAuthenticated'))
    //   if (isAuthenticated) {
    //     userProfile = JSON.parse(self.getPromptPaiCookies('UserProfile'))
    //     uuid = undefined
    //   }
    //   self.pp.getReceivedPlaces(
    //     'name' in userProfile ? userProfile.name : undefined,
    //     'longdousertoken' in userProfile ? userProfile.longdousertoken : undefined,
    //     isAuthenticated ? undefined : uuid,
    //     0,
    //     undefined,
    //     (result) => {
    //       if (result.status.code === 200) {
    //         self.receivedPlaceList = result.data
    //       } else if (result.status.code === 403) {
    //       } else {
    //       }
    //       self.isFinished = true
    //     }
    //   )
    // },
    clickMiniReceivedPlaceCardButton (id, notiId) {
      var self = this
      if (notiId !== null) {
        var userProfile = {}
        var uuid = JSON.parse(self.getPromptPaiCookies('Uuid'))
        var isAuthenticated = JSON.parse(self.getPromptPaiCookies('isAuthenticated'))
        if (isAuthenticated) {
          userProfile = JSON.parse(self.getPromptPaiCookies('UserProfile'))
          uuid = undefined
        }
        self.pp.getPromptpaiDescription(
          id,
          'name' in userProfile ? userProfile.name : undefined,
          'longdousertoken' in userProfile ? userProfile.longdousertoken : undefined,
          uuid,
          notiId,
          undefined,
          undefined
        )

        var userAgent = self.util.getUserAgentMeta()
        if (userAgent === 'Android application') {
          Android.cancelNotification(Number(notiId))
        }

        self.$router.push({
          path: `/p/${id}`,
          query: {
            notiid: notiId
          }
        })
      } else {
        self.$router.push({
          path: `/p/${id}`
        })
      }
      // self.$router.back()
    }
  },
  beforeDestroy () {
    var self = this
    self.$root.$off('refreshReceivedLocationList')
  }
}
</script>

<style scoped>
  .received-place-list {
    width: 320px;
    height: 480px;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    position: relative;
    overflow: hidden;
    margin-top: auto;
    margin-bottom: auto;
  }

  .head {
    display: flex;
    flex-direction: row;
    background-color: rgb(255, 255, 255);
  }

  .tab {
    height: 36px;
    width: calc(100% / 3);
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgb(255, 255, 255);
    cursor: pointer;
    padding: 0px;
    border-bottom: 2px solid rgb(255, 255, 255);
  }

  .tab.active {
    box-shadow: 0px -5px 4px 0 rgba(0, 0, 0, 0.1);
    -webkit-appearance: none;
    border-bottom: 2px solid rgb(34, 84, 156);
    z-index: 1;
  }

  .tab > img {
    width: 36px;
    height: 36px;
    margin-left: -9px;
  }

  .tab > label {
    font-family: Prompt;
    font-size: 14px;
    margin-left: 4px;
    cursor: pointer;
    color: rgb(106, 105, 105);
  }

  .tab.active > label {
    color: rgb(34, 84, 156);
  }

  .body {
    height: calc(430px - 36px);
    box-sizing: border-box;
    background: rgb(255, 255, 255);
    position: relative;
    overflow: hidden;
    overflow-y: auto;
  }

  .body::-webkit-scrollbar-button {
    height: 12.5px;
  }
  .body::-webkit-scrollbar {
    background-color: rgb(251, 251, 251);
  }
  .body::-webkit-scrollbar-thumb {
    border: 2px solid rgb(251, 251, 251);
  }

  button.mini-received-place-card-button {
    border: none;
    background-color: transparent;
    width: 100%;
    padding: 4px 0px 8px 0px;
    border-bottom: 1px solid rgb(227, 227, 227);
    cursor: pointer;
  }

  button.mini-received-place-card-button.new {
    background-color: rgba(34, 84, 156, 0.1);
  }

  .loading-animation-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .empty-list {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 18px;
    color: rgb(120, 120, 120);
  }

  @media only screen and (max-width: 768px) {
    .received-place-list {
      width: 100%;
      min-width: 320px;
      height: 100%;
      border-radius: 0px;
    }

    .body {
      height: calc(100% - 50px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ReceivedPlaceList.vue